{
    "name": "client-app",
    "version": "4.0.0",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build": "ng build",
        "test": "ng test",
        "lint": "ng lint",
        "e2e": "ng e2e",
        "build:stats": "ng build --configuration production --stats-json",
        "analyze": "webpack-bundle-analyzer dist/stats-es2015.json"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^18.2.13",
        "@angular/common": "^18.2.13",
        "@angular/compiler": "^18.2.13",
        "@angular/core": "^18.2.13",
        "@angular/forms": "^18.2.13",
        "@angular/localize": "^18.2.13",
        "@angular/platform-browser": "^18.2.13",
        "@angular/platform-browser-dynamic": "^18.2.13",
        "@angular/router": "^18.2.13",
        "@auth0/angular-jwt": "^5.2.0",
        "@azure/msal-angular": "^4.0.12",
        "@azure/msal-browser": "^4.13.2",
        "@microsoft/signalr": "^9.0.6",
        "@ng-bootstrap/ng-bootstrap": "^17.0.1",
        "@ng-select/ng-select": "^13.9.1",
        "@ngx-formly/bootstrap": "^6.3.12",
        "@ngx-formly/core": "^6.3.12",
        "@popperjs/core": "^2.11.8",
        "@tinymce/tinymce-angular": "^8.0.1",
        "bootstrap": "5.3",
        "date-fns": "^2.29.3",
        "file-saver": "^2.0.5",
        "ng-multiselect-dropdown": "^1.0.0",
        "ngx-bootstrap": "^18.1.3",
        "ngx-cookie-service": "^18.0.0",
        "ngx-extended-pdf-viewer": "^23.3.1",
        "rxjs": "^7.0.0",
        "tinymce": "7.5",
        "tslib": "^2.0.0",
        "xstate": "^4.6.1",
        "zone.js": "~0.14.10"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^18.2.20",
        "@angular/cli": "^18.2.20",
        "@angular/compiler-cli": "^18.2.13",
        "@angular/language-service": "^18.2.13",
        "@microsoft/microsoft-graph-types": "^1.12.0",
        "@types/file-saver": "^2.0.7",
        "@types/jasmine": "~3.3.8",
        "@types/jasminewd2": "~2.0.3",
        "@types/node": "^12.11.1",
        "jasmine-core": "^5.1.1",
        "jasmine-spec-reporter": "~5.0.0",
        "karma": "~6.4.1",
        "karma-chrome-launcher": "~3.1.0",
        "karma-coverage": "^2.2.1",
        "karma-jasmine": "~4.0.0",
        "karma-jasmine-html-reporter": "^1.5.0",
        "postcss": "^8.4.21",
        "ts-node": "~7.0.0",
        "typescript": "5.4"
    }
}